// extracted by mini-css-extract-plugin
export default {"locationReturnSwitcher":"FvEWN","locationInnerText":"_8ZvR1","skeleton-progress":"MtSsN"};